<template>
	<div v-if="selectedCity" class="flex flex-col gap-4">
		<h2 class="pl-3 text-base font-medium leading-[24px]">
			Bairros em destaque
		</h2>
		<div class="flex flex-col">
			<NuxtLink
				v-for="region in selectedCity.regions"
				:key="region.slug"
				class="flex flex-row items-center gap-3 p-3 transition-all hover:bg-primary-light-3"
				:to="getRegionUrl(region)"
				@click="addEventRegion(region)"
			>
				<IconPilarMapPoint class="size-4 text-beige" />
				<span class="pt-1 text-sm leading-[21px]">{{ region.name }}</span>
			</NuxtLink>
		</div>
		<hr class="border-primary-light-3" />
		<NuxtLink
			class="flex items-center gap-3 p-3 text-sm leading-[21px] transition-all hover:bg-primary-light-3"
			:to="cityUrl"
		>
			<span>Ver tudo em {{ selectedCity.name }}</span>
			<IconMaterialSymbolsLightNorthEast class="size-4 text-beige" />
		</NuxtLink>
	</div>
</template>

<script setup lang="ts">
import type { City, Region } from '.';
import { useEvents } from '~/composables/events/useEvents';
const { trackHeader } = useEvents();

const selectedCity = defineModel<City | null>('selectedCity', {
	default: null
});

function getRegionUrl(region: Region) {
	return normalizeString(
		`/venda/imoveis/${region.slug}-${region.city}-${selectedCity.value?.state}-${selectedCity.value?.country}`,
		['-', '/']
	);
}

const cityUrl = computed(() => {
	const path = normalizeString(
		`/venda/imoveis/${selectedCity.value?.state}-${selectedCity.value?.country}`,
		['-', '/', '?', '=']
	);

	const queryStringObject = new URLSearchParams();

	queryStringObject.set('macroregions', selectedCity.value?.name || '');

	return `${path}?${queryStringObject.toString()}`;
});

const addEventRegion = (region: Region) => {
	trackHeader.handleEventMenuHeaderClick({
		clickedButton: region.name,
		action: 'buy',
		clickNeighborhood: true,
		destinationUrl: getRegionUrl(region),
		regionDescription: selectedCity?.value?.name || ''
	});
};
</script>
